<template>
    <div class="wl-active-detail clearfix">
        <div class="active-detail-title clearfix">
            <h3 class="h3-title-top">{{attestationInfo.Title}}</h3>
            <span class="sp-left">来源：{{attestationInfo.SiteName}}</span> <span class="sp-right">发布时间：{{attestationInfo.PulishTime}}</span>
        </div>
        <div class="active-content-text">
            <p v-html="attestationInfo.Content"></p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        activeId:{
            type: String,
            default: ''
        }
    },
    data() {
        return{
            attestationInfo:[],
        }
    },
    created() {
        this.getAttestationInfo();
    },
    methods: {
    //获取活动详情
    getAttestationInfo(){
      var that = this;
      debugger;
      this.$http.post(
        '/api/XOrg/AttestationActivity/getAttestationInfo',
        {
          Id: that.activeId
        }
      )
      .then(rst =>{
        if(rst.code ==1){
          that.attestationInfo= rst.attestationInfo
        }else {
          that.$message.warning(rst.msg);
        }
      });
    }
  }
}
</script>

<style lang="scss">
.wl-active-detail{
    margin-top: 30px;
    margin-bottom: 30px;
    border: 1px solid #E9EBF0;
    padding: 30px 55px;
    .active-detail-title{
        border-bottom: 2px solid #E9EBF0;
        padding-bottom: 20px;
        .h3-title-top{
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            text-align: center;
        }
        .sp-left{
            float: left;
            color: #999999;
            font-size: 14px;
            margin-top: 19px;
            width: 43%;
            text-align: right;
        }
        .sp-right{
            float: right;
            color: #999999;
            font-size: 14px;
            margin-top: 19px;
            width: 42%;
        }
    }
    .active-content-text{
        p{
            padding: 22px 0; 
            color: #333333;
            font-size: 14px;
            line-height: 21px;
        }
        img {
            display: block;
            margin: 20px auto 0;
            max-width: 80%;
        }
    }
}
</style>

